import ProvidersSlide from "../../../components/providers-slide";
import GameInfo from "../info";
import {useEffect, useRef, useState} from "react";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useSelector} from "react-redux";
import associateServices from "../../../services";
import store from "../../../reducers/createReducers";
import GLOBAL_ACTIONS from "../../../actions/global-actions";
import {toast} from "react-toastify";
import NewGames from "../../../components/new-games";
import '../index.css'
import InformationToast from "../../../components/toast/InformationToast";
import {useTranslation} from "react-i18next";
import PlayGameWebFrame from "./frame-web";
import GeneralStats from "../../../components/debit-table/casino-debit-stats";
import {Helmet} from "react-helmet-async";
import stringHelper from "../../../helpers/string-helper";

const PlayGameWeb = () => {
    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language

    let {slug} = useParams()
    const {configuration} = useSelector(state => state.globalReducer)
    const navigate = useNavigate()
    const {authenticated, selectedWallet} = useSelector(state => state.authenticationReducer)
    const {gameSelectedCurrency, activeLanguage} = useSelector(state => state.globalReducer)
    const [favorited, setFavorited] = useState(false)
    const [currencies, setCurrencies] = useState([])
    const [gameType, setGameType] = useState('')
    const [gameUiURL, setGameUiURL] = useState('')
    const [game, setGame] = useState(null)
    const [showConf, setShowConf] = useState(true)
    const [error, setError] = useState('')

    const [json, setJson] = useState({})


    useEffect(() => {

        const oldNode = document.getElementById('game')
        oldNode?.remove()

        setError('')
        setGameUiURL('')


        setShowConf(true)

        associateServices.playGame({slug, language: activeLanguage?.key}).then(res => {

            if (res?.status !== 200)
                return setError(res?.errors || '')

            setGame(res?.data?.game)
            if (res?.data?.game?.is_live || !res?.data?.game?.has_demo) {
                if (!authenticated) {
                    navigate(stringHelper.getModalPath('register', searchParams))
                    setGameType('demo')
                } else {
                    setConf(res?.data?.game, res?.data?.favorited)
                    setGameType('real')
                }
            } else {
                setConf(res?.data?.game, res?.data?.favorited)

                setGameType(authenticated ? 'real' : 'demo')
            }

        })

        return () => store.dispatch(GLOBAL_ACTIONS.setInPlayAction(false))
    }, [slug, authenticated, activeLanguage?.key])

    const setConf = (game, favorited) => {

        // if (!game?.game_provider?.currencies?.includes(gameSelectedCurrency))
        //     store.dispatch(GLOBAL_ACTIONS.setSelectedCurrency(game?.game_provider?.currencies[0]))

        let webCurrencies = game?.currencies || game?.game_provider?.currencies

        try {
            if (game?.currencies)
                webCurrencies = JSON.parse(game?.currencies)
        } catch (e) {
            console.error(e)
        }
        store.dispatch(GLOBAL_ACTIONS.setInPlayAction(true))
        setFavorited(favorited)

        if (gameSelectedCurrency) {

            if (webCurrencies?.length >= 1 && !webCurrencies?.includes(gameSelectedCurrency)) {
                store.dispatch(GLOBAL_ACTIONS.setSelectedCurrency(webCurrencies[0]))
            }
        } else {
            if (webCurrencies?.length >= 1) {
                store.dispatch(GLOBAL_ACTIONS.setSelectedCurrency(webCurrencies[0]))
            }
        }


        setCurrencies(webCurrencies)
    }


    useEffect(() => {
        console.log({
            game,
            gameSelectedCurrency,
            gameType
        })
        if (game && gameSelectedCurrency && gameType) {
            // setShowConf(true)
            setJson({})


            const value = {
                id: game?.id,
                currency: gameSelectedCurrency,
                type: gameType,
                code: selectedWallet?.code,
                language: activeLanguage?.key,
                device: 'desktop'
            }
            associateServices.getGameURL(value).then(res => {

                if (res?.status !== 200) {

                    toast(<InformationToast
                        icon={'ti-x'}
                        title={t(`general.information`)}
                        message={t(`api-notifications.${res?.errors}`)}
                    />)
                    // toast.error(t(`api-notifications.${res?.errors}`))
                    return setError(res?.errors)
                }


                try {
                    const responsed = JSON.parse(res?.data?.url)


                    const isRedirect = responsed?.gameScript.includes('location.replace');

                    if (isRedirect) {
                        const urlMatch = responsed?.gameScript.match(/location\.replace\("([^"]+)"\);/);
                        if (urlMatch && urlMatch[1]) {
                            console.error('urlMatch[1] = ', urlMatch[1])
                            setJson({
                                gameHtml: `<iframe src="${urlMatch[1]}" class="iframes"/>`
                            });
                        } else {
                            setJson(responsed);
                        }
                    } else {
                        setJson(responsed);
                    }

                } catch (e) {

                    setJson({
                        gameHtml: `<iframe src="${res?.data?.url || res?.data}" class="iframes"/>`
                    });

                    // launchGameInSelfIframe(res?.data?.url)
                }
            })

        }
    }, [gameSelectedCurrency, gameType, game, selectedWallet?.code, authenticated])


    const [searchParams, setSearchParams] = useSearchParams()

    const handleSetGameType = (type) => {
        if (type === 'register') {
            searchParams.set('modal', type);
            setSearchParams(searchParams);
            return;
            // return store.dispatch(GLOBAL_ACTIONS.setModalTypeAction('register'))
        } else
            setGameType(type)

        setShowConf(false)
    }


    return (
        <>
            <Helmet>
                {
                    game?.name && <>
                        <title>{`${game?.seo?.seo_title ?? `${game?.name} ${configuration?.domain}`}`}</title>
                        <meta name="description" content={game?.seo?.seo_description ?? ''}/>
                        <meta name="keywords" content={game?.seo?.seo_keywords ?? ''}/>
                        <meta property="og:title"
                              content={`${game?.seo?.seo_title ?? `${game?.name} ${configuration?.domain}`}`}/>
                        <meta name="og:description" content={game?.seo?.seo_description ?? ''}/>
                        <meta property="og:image" content={game?.image}/>
                        <meta name="robots" content="index, follow"/>
                        <meta name="robots" content={game?.seo?.seo_robots ?? ''}/>
                        <meta name="google_robots" content={game?.seo?.seo_googlebot ?? ''}/>
                    </>
                }

            </Helmet>


            <div className="section section--first">
                <div className="container">
                    <div className="row">
                        <div className="col-12">


                            <PlayGameWebFrame {...{
                                json,
                                gameUiURL,
                                showConf,
                                handleSetGameType,
                                currencies,
                                game,
                                gameType,
                                favorited,
                                setGameType,
                                error,
                                setFavorited
                            }}/>

                        </div>

                        <GameInfo game={game}/>
                    </div>
                </div>
            </div>

            <NewGames/>

            <GeneralStats/>

            <ProvidersSlide/>
        </>

    )


}

export default PlayGameWeb
